import React from "react";
import { Route, Switch } from "react-router-dom";

import Welcome from "./welcome";
import UserRouter from "../user/user.router";
import { AdminRouter } from "../admin";

const HomeRouter = props => {
  const { username } = props;
  return (
    <Switch>
      <Route path="/user" render={() => <UserRouter {...props} />} />
      <Route path="/admin" render={() => <AdminRouter {...props} />} />
      <Route
        path="/"
        render={() => {
          return <Welcome username={username} />;
        }}
      />
    </Switch>
  );
};

export default HomeRouter;
